import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from "react-intl";
import './InterventionStatus.css';

class InterventionStatus extends React.Component {

  render() {
    const {intl:{formatMessage}} = this.props;

    const {status, previousStatus} = this.props;
    return(
    <div>
      <span className="table-status"><strong>{formatMessage({id:`intervention.status.${status}`})}</strong></span>
      <span className="table-prev-status">{previousStatus && formatMessage({id:`intervention.status.${previousStatus}`})}</span>
    </div>
  )
  }
}


export default injectIntl(InterventionStatus);

InterventionStatus.propTypes ={
  status: PropTypes.string,
  previousStatus: PropTypes.string
}




// WEBPACK FOOTER //
// ./src/components/common/format/InterventionStatus.js